import script from "./CreateColor.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateColor.vue?vue&type=script&setup=true&lang=js"

import "./CreateColor.vue?vue&type=style&index=0&id=06b59583&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b59583"]])

export default __exports__